<template>
  <div class="additionalList__item" >
    <div class="baseAccordion">
      <BaseAccordion>
        <template v-slot:name>
          <p>{{ additional.name }}</p>
          <label class="form-switch" @click.stop>
            <input type="checkbox" :value="additional.id" :checked="checked" @input="$emit('toggleSwitch', additional.id)">
            <i></i>
          </label>
        </template>
        <template v-slot:content>
          <p>{{ additional.description }}</p>
        </template>
      </BaseAccordion>
    </div>
    <div class="quote__dropdown">
      <button type="button" class="quote__dropdown-btn"
        @click.prevent="expandedList = true"
        @blur="expandedList = false">
        <div class="quote__dropdown-content">
          <div class="quote__dropdown-label" v-if="!loading">{{$t('home_additional_insurance')}}</div>
          <div class="quote__dropdown-amount">
            <Loader v-if="loading"/>
            <template v-else> {{$t('qic_qar')}} {{ additional.cover | splitNumber }} <span>+ {{$t('qic_qar')}} {{ additional.value }}</span></template>
          </div>
        </div>
        <i class="sep">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.20921 6.68306C3.48816 6.43898 3.94042 6.43898 4.21936 6.68306L8 9.99112L11.7806 6.68306C12.0596 6.43898 12.5118 6.43898 12.7908 6.68306C13.0697 6.92714 13.0697 7.32286 12.7908 7.56694L8.50508 11.3169C8.22613 11.561 7.77387 11.561 7.49492 11.3169L3.20921 7.56694C2.93026 7.32286 2.93026 6.92714 3.20921 6.68306Z" fill="#526C82" fill-opacity="0.8"/>
          </svg>
        </i>
      </button>
      <ul @mousedown.prevent class="quote__dropdown-list" v-if="covers.length && expandedList && !loading">
        <li
          v-for="(coverValue, index) of covers"
          :key="index"
          @click="changeCover(coverValue)">
          {{$t('qic_qar')}} {{ coverValue | splitNumber }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { BaseAccordion, Loader } from 'qic-components'
export default {
  name: 'HomeAdditionalItem',
  props: {
    additional: { type: Object },
    covers: { type: Array },
    checked: { type: Boolean, defaul: false }
  },
  emits: [
    'toggleSwitch',
    'changeCover'
  ],
  components: {
    BaseAccordion,
    Loader
  },
  data () {
    return {
      expandedList: false
    }
  },
  computed: {
    loading () {
      return this.additional?.loader || false
    }
  },
  methods: {
    changeCover (value) {
      this.$emit('changeCover', { id: this.additional.id, value })
      this.expandedList = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .quote__dropdown-list {
    display: block;
  }
</style>
